// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM5 5V19H19V5H5ZM13.8535 17H7V14.6816L9.26758 12.4141L13.8535 17ZM17 7V17H16.6816L9.26758 9.58594L7 11.8535V7H17ZM14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8Z"}}]};

const ViewImageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-image-filled',
    ref,
    icon: element,
  },
));

ViewImageFilledIcon.displayName = 'ViewImageFilledIcon';

export default ViewImageFilledIcon;
